import ProcessFlowBuilderModel from "~/models/tracked/processFlowBuilderModel";
import {SortOption} from "~/sortOption";
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable";
import {IFindDataStep, IProcessFlowMappedVariable, IProcessFlowSortationCriteria} from "~/interfaces/processFlowInterfaces";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {RelationType} from "~/models/relationType";
import {Hash} from "~/interfaces/hashInterfaces";
import {IClientIdable} from "~/interfaces/propertyInterfaces";

export default class ProcessFlowSortationCriteria extends ProcessFlowBuilderModel implements IProcessFlowSortationCriteria {
  sort_order: number;
  field_reference: ProcessFlowMappedVariable;
  direction: SortOption;

  constructor(parent: IFindDataStep) {
    super();
    this.parent = parent;
    this._nameInParent = 'sortation_criteria';
    this._isCollectionRoot = true;
    this.defineClientId();
    this.defineProperty('sort_order', 0);
    this.defineProperty('direction', SortOption.ASC);
  }

  get rootName(): string {
    return this._nameInParent;
  }

  get isCollectionRoot(): boolean {
    return this._isCollectionRoot;
  }

  get fieldReference(): IProcessFlowMappedVariable {
    return this.field_reference || this.createFieldReference();
  }

  createFieldReference(): IProcessFlowMappedVariable {
    const ref = this.createEmbeddedObject.field_reference(this, {});
    ref.attachToParent(this);
    return ref;
  }

  isComplete(): boolean {
    return !!this.fieldReference.source_variable_path?.nodes?.length && [SortOption.ASC, SortOption.DESC].includes(this.direction);
  }

  toHtmlString(): string {
    const fieldLabel = this.fieldReference.source_variable_path?.dynamicFieldName || `<span class="text-danger">Unconfigured</span>`;
    const direction = this.direction === SortOption.ASC ? 'Ascending' : 'Descending';
    return `<strong>${fieldLabel}</strong> ${direction}`;
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<ProcessFlowSortationCriteria> = new Repo<ProcessFlowSortationCriteria>('processFlowSortationCriteria', ProcessFlowSortationCriteria, {});
  repo: IRepo<this>;

  addToRepo(): void {
    ProcessFlowSortationCriteria.repo.add(this)
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      "field_reference": { type: ProcessFlowMappedVariable, relationType: RelationType.singleObject },
    }
  }

  createEmbeddedObject = {
    field_reference: (parent, json: Hash & Partial<IClientIdable>): ProcessFlowMappedVariable => {
      return ProcessFlowMappedVariable.repo.findOrCreateWith(json.client_id, 'field_reference').loadFromJson(json, parent);
    },
  }

  // ******************** ISortable START ******************** //
  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  get isLast(): boolean {
    return this.sort_order === this.parent.nextSortOrderFor(this.rootName) - 1;
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.parent.updateSortOrder(this.rootName, this, this.sort_order);
    }
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.parent.updateSortOrder(this.rootName, this, this.sort_order);
    }
  }
  // ******************** ISortable END ******************** //

}